<template>
  <v-container
    v-if="items.length > 0"
    class="pa-0"
    v-bind="{ [`grid-list-md`]: true }"
    fluid
  >
    <v-layout class="ma-0 pa-0" style="overflow: hidden; overflow-x: auto">
      <v-flex
        :style="{
          'min-width': getMultipleCardWidth(items.length),
          'max-width': getMultipleCardWidth(items.length),
        }"
        v-for="subItem in items"
        :key="subItem.Header"
      >
        <base-contentpage-landingpage-card
          :maxWidth="getMultipleCardWidth(items.length)"
          small
          :item="subItem"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BaseContentpageLandingpageCard from "@/components/contentpage/base/BaseContentpageLandingpageCard";

export default {
  components: {
    BaseContentpageLandingpageCard,
  },
  props: {
    items: { type: Array, default: () => [] },
  },
  methods: {
    getMultipleCardWidth(cardsCnt) {
      if (cardsCnt * 180 <= this.$vuetify.breakpoint.width) {
        return `${100 / cardsCnt}%`;
      }

      var divisor = Math.round(this.$vuetify.breakpoint.width / 180) + 0.325;
      return this.$vuetify.breakpoint.width / divisor + "px";
    },
  },
};
</script>
